import React, { useState } from "react";
import { useLocation, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import ManageBranches from "../pages/Branches/ManageBranches";
import ManageItemCategories from "../pages/ItemCategories/ManageItemCategories";
import ManageItemAvailability from "../pages/ItemAvailability";
import Vendor from "../pages/vendor";
import ManageItems from "../pages/Items/ManageItems";
import ManageTables from "../pages/Tables/ManageTables";
import ManageHotKeys from "../pages/HotKeys/ManageHotKeys";
import ManageTableTypes from "../pages/TableTypes/index";
// import ManageCategoryTypes from "../pages/CategoryTypes/index";
import ManageExpense from "../pages/Expense/index";
import ManageBranchExpense from "../pages/Expense/BranchExpense";

import AddRestaurant from "../pages/Restaurant/ManageRestaurant";
import ManageSubScriptions from "../pages/Subscriptions/ManageSubscriptions";
import ManageThemes from "../pages/Themes/ManageThemes";
import ManageUsers from "../pages/Users/ManageUsers";
import AddModal from "../pages/Users/ManageUsers/AddModal";
import { useSelector } from "react-redux";
import OrderDashboard from "../pages/OrderDashboard";

import LeftSideBar from "../components/LeftSideBar/index";
import TopBar from "../components/TopBar";
import DashBoard from "../pages/DashBoard";
import Reports from "../pages/Reports";
import ManageExpenseTypes from "../pages/ExpenseTypes";
import RestaurantExpenseTypes from "../pages/ExpenseTypes/RestaurantExpenseTypes";
import BookingSpaces from "../pages/Bookings";

import OrderHistory from "../pages/OrderHistory";

import ExpiredSubscription from "../pages/ExpiredSubscription";
// import BranchAdminSettings from "../pages/Settings/BranchAdminSettings";
import Settings from "../pages/Settings";
import ManageRawMaterials from "../pages/RawMaterials";
import KitchenDisplay from "../pages/KitchenDisplay";
import { SCOPES } from "../contants";
import OrderSummaryData from "../pages/OrderSummaryData";

const DashBoardRoutes = () => {
  const role = useSelector((state) => state.user.role);
  const { pathname } = useLocation();
  const [sideMenuOpen, setSideMenuOpen] = useState(false);

  const isBranchAdmin = role === "branchadmin";
  const isBranchUser = role === "branchuser";
  const isRestaurantAdmin = role === "restaurantadmin";
  const isKitchenUser = role === "kitchenuser";

  const superadmin = "superadmin";
  const restaurantadmin = "restaurantadmin";
  const branchadmin = "branchadmin";
  const branchuser = "branchuser";
  const kitchenuser = "kitchenuser";
  const isFullPageDashboard = pathname === "/order" || pathname === "/kitchen" || (pathname === "/" && (isBranchUser || isKitchenUser));

  return (
    <div
      className="data-container"
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "row",
        overflow: "hidden",
      }}
    >
      {!isKitchenUser && (
        <LeftSideBar
          sideMenuOpen={sideMenuOpen}
          setSideMenuOpen={setSideMenuOpen}
        />
      )}

      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          height: "100%",
          minHeight: 0,
          minWidth: 0,
        }}
      >
        <div style={{ flexShrink: 0 }}>
          <TopBar
            hide={isBranchUser && pathname === "/"}
            sideMenuOpen={sideMenuOpen}
            setSideMenuOpen={setSideMenuOpen}
          />
        </div>
        <div
          className={`dashboard-container ${isFullPageDashboard ? "p-0" : ""}`}
          style={{ flex: 1, width: "100%", overflow: "auto", minHeight: 0 }}
        >
          <Routes>
            {isBranchUser && <Route path="/" element={<OrderDashboard />} />}
            {isKitchenUser && (
              <Route
                path="/"
                element={
                  <ProtectedRoute
                    roles={[kitchenuser]}
                    component={KitchenDisplay}
                  />
                }
              />
            )}

            <Route
              path="/order"
              element={
                <ProtectedRoute
                  roles={[branchadmin, branchuser]}
                  component={OrderDashboard}
                />
              }
            />
            <Route
              path="/kitchen"
              element={
                <ProtectedRoute
                  roles={[kitchenuser]}
                  component={KitchenDisplay}
                  scopes={[SCOPES.KITCHEN_DISPLAY_SYSTEM]}
                />
              }
            />
            <Route
              path="/"
              element={
                <ProtectedRoute
                  roles={[superadmin, branchadmin, restaurantadmin]}
                  component={DashBoard}
                />
              }
            />
            <Route
              path="/managerestaurant"
              element={
                <ProtectedRoute
                  roles={[superadmin]}
                  component={AddRestaurant}
                />
              }
            />

            <Route
              path="/bookings"
              element={
                <ProtectedRoute
                  roles={[branchadmin, restaurantadmin]}
                  component={BookingSpaces}
                  scopes={[SCOPES.BOOKING_SYSTEM]}
                />
              }
            />

            <Route
              path="/managebranches"
              element={
                <ProtectedRoute
                  roles={[superadmin, restaurantadmin]}
                  component={ManageBranches}
                />
              }
            />

            <Route
              path="/manageusers"
              element={
                <ProtectedRoute
                  roles={[superadmin, restaurantadmin, branchadmin]}
                  component={ManageUsers}
                />
              }
            />

            <Route
              path="/adduser"
              element={
                <ProtectedRoute
                  roles={[superadmin, restaurantadmin]}
                  component={AddModal}
                />
              }
            />

            <Route
              path="/managethemes"
              element={
                <ProtectedRoute roles={[superadmin]} component={ManageThemes} />
              }
            />

            <Route
              path="/managesubscriptions"
              element={
                <ProtectedRoute
                  roles={[superadmin]}
                  component={ManageSubScriptions}
                />
              }
            />

            <Route
              path="/managecategories"
              element={
                <ProtectedRoute
                  roles={[restaurantadmin, superadmin, branchadmin]}
                  component={ManageItemCategories}
                />
              }
            />

            <Route
              path="/manageitems"
              element={
                <ProtectedRoute
                  roles={[restaurantadmin, branchadmin]}
                  component={ManageItems}
                />
              }
            />

            <Route
              path="/manageitemavailability"
              element={
                <ProtectedRoute
                  roles={[branchadmin]}
                  component={ManageItemAvailability}
                />
              }
            />

            <Route
              path="/vendor"
              element={
                <ProtectedRoute roles={[branchadmin]} component={Vendor} />
              }
            />

            <Route
              path="/managetables"
              element={
                <ProtectedRoute
                  roles={[restaurantadmin, branchadmin]}
                  component={ManageTables}
                />
              }
            />
            <Route
              path="/managerawmaterials"
              element={
                <ProtectedRoute
                  roles={[branchadmin]}
                  component={ManageRawMaterials}
                />
              }
            />
            <Route
              path="/managehotkeys"
              element={
                <ProtectedRoute
                  roles={[restaurantadmin, branchadmin]}
                  component={ManageHotKeys}
                />
              }
            />

            <Route
              path="/managetabletypes"
              element={
                <ProtectedRoute
                  roles={[superadmin, restaurantadmin]}
                  component={ManageTableTypes}
                />
              }
            />
            <Route
              path="/manageexpensetypes"
              element={
                <ProtectedRoute
                  roles={[superadmin]}
                  component={ManageExpenseTypes}
                />
              }
            />

            <Route
              path="/manageexpense"
              element={
                <ProtectedRoute
                  roles={[restaurantadmin, branchadmin, branchuser]}
                  component={
                    isRestaurantAdmin
                      ? RestaurantExpenseTypes
                      : ManageBranchExpense
                  }
                />
              }
            />

            <Route
              path="/orderhistory"
              element={
                <ProtectedRoute
                  roles={[restaurantadmin, branchadmin]}
                  component={OrderHistory}
                />
              }
            />

            <Route
              path="/ordersummary"
              element={
                <ProtectedRoute
                  roles={[restaurantadmin, branchadmin]}
                  component={OrderSummaryData}
                />
              }
            />

            <Route
              path="/settings"
              element={
                <ProtectedRoute
                  roles={[branchadmin, branchuser]}
                  component={Settings}
                />
              }
            />
            {/* 
            <Route
              path="/managecategorytypes"
              element={
                <ProtectedRoute
                  roles={[superadmin]}
                  component={ManageCategoryTypes}
                />
              }
            /> */}

            <Route
              path="/reports/:reportType"
              element={
                <ProtectedRoute
                  roles={[restaurantadmin, branchadmin]}
                  component={Reports}
                />
              }
            />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default DashBoardRoutes;
